@if (bookmarkedAssetList.hasValue() && bookmarkedAssetList.value()?.items.length > 0) {
  <div class="home__section-header-row">
    <h3 class="home__section-title">Recent Bookmarks</h3>
    <!-- TODO: uncomment when button is needed -->
    <!-- <button class="home__explore-btn" disabled> -->
    <!--   See all -->
    <!--   <svg -->
    <!--     width="14" -->
    <!--     height="14" -->
    <!--     viewBox="0 0 24 24" -->
    <!--     fill="none" -->
    <!--     stroke="currentColor" -->
    <!--     stroke-width="2.5" -->
    <!--     stroke-linecap="round" -->
    <!--     stroke-linejoin="round" -->
    <!--   > -->
    <!--     <path d="M5 12h14M12 5l7 7-7 7" /> -->
    <!--   </svg> -->
    <!-- </button> -->
  </div>
  <div class="assets-container">
    @if (bookmarkedAssetList.isLoading()) {
      <div class="placeholder-container">
        <loader size="64px" />
      </div>
    } @else if (bookmarkedAssetList.hasValue()) {
      <div class="home__card-row">
        @for (asset of bookmarkedAssetList.value()?.items; track asset.asset_id) {
          <asset-card [asset]="asset" />
        }
      </div>
    } @else {
      <div class="placeholder-container">
        <p class="empty-placeholder">Bookmark an asset to see it here!</p>
      </div>
    }
  </div>
}
